var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"hide-header":"","hide-footer":"","centered":"","close-on-backdrop":""},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.hide}},[_vm._v(" × ")])]),_c('div',{staticClass:"preview-box b-contain img",style:({
        'background-image': 'url(' + _vm.img + ')',
      })})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }